// ==============================|| MENU ITEMS - SUPERVISOR ||============================== //

const supervisorMenu = {
  id: 'group-supervisor',
  title: 'Módulo de Supervisión',
  type: 'group',
  children: [
    {
      id: 'supervisor-panel',
      title: 'Supervisor',
      icon: 'ph ph-shield-check',
      type: 'collapse',
      children: [
        {
          id: 'sup-listar-usuarios',
          title: 'Usuarios de Mi Entidad',
          type: 'item',
          url: '/admin/listar-usuarios'
        },
        {
          id: 'sup-gestion-entidades',       // 👈 NUEVO
          title: 'Gestionar Mis Entidades',  // 👈 NUEVO
          type: 'item',                       // 👈 NUEVO
          url: '/admin/gestion-entidades'     // 👈 NUEVO
        },
        {
          id: 'sup-seguimiento-cargas',
          title: 'Seguimiento de Cargas',
          type: 'item',
          url: '/admin/seguimiento-cargas'
        }
      ]
    }
  ]
};

export default supervisorMenu;